<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{ $t('message.admin.mst.group.title.add') }}</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.mst.group.error." />
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.groupLarge') }}</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-radio-group v-model="form.groupLargeId" dense class="mt-0 pt-0">
            <v-radio
              v-for="(groupLarge, index) in view.groupList"
              :key="index"
              :label="groupLarge.groupLargeName.ja"
              :value="groupLarge.groupLargeId"
              :id="`groupLargeId-${groupLarge.groupLargeId}`"
            ></v-radio>
          </v-radio-group>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.groupSmall') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.groupSmallNameJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.groupSmallNameJp')"
            id="groupSmallNameJp"
            solo
            maxlength="50"
          ></v-text-field>
          <v-text-field
            v-model="form.groupSmallNameEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.groupSmallNameEn')"
            id="groupSmallNameEn"
            solo
            maxlength="50"
            class="mt-2"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.companyLabel') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.companyLabelJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.companyLabelJp')"
            id="companyLabelJp"
            solo
            maxlength="50"
          ></v-text-field>
          <v-text-field
            v-model="form.companyLabelEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.companyLabelEn')"
            id="companyLabelEn"
            solo
            class="mt-2"
            maxlength="50"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.branchLabel') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.branchLabelJp"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.branchLabelJp')"
            id="branchLabelJp"
            solo
            maxlength="50"
          ></v-text-field>
          <v-text-field
            v-model="form.branchLabelEn"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.branchLabelEn')"
            id="branchLabelEn"
            solo
            class="mt-2"
            maxlength="50"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{ $t('message.admin.mst.group.label.displayOrder') }}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>
          <v-text-field
            v-model="form.displayOrder"
            hide-details
            v-bind:placeholder="$t('message.admin.mst.group.ph.displayOrder')"
            id="displayOrder"
            solo
            maxlength="2"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.mst.group.label.accountEntryDisplayFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox
          hide-details
          dense
          class="my-2 py-0"
          v-model="form.accountEntryDisplayFlg"
          :label="$t('message.admin.mst.group.ph.accountEntryDisplayFlg')"
          id="accountEntryDisplayFlg"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.mst.group.label.adminUpdFlg")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-checkbox
          hide-details
          dense
          class="my-2 py-0"
          v-model="form.adminUpdFlg"
          :label="$t('message.admin.mst.group.ph.adminUpdFlg')"
          id="adminUpdFlg"
        ></v-checkbox>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goList">{{ $t('message.admin.mst.group.button.back') }}</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goRegister">{{ $t('message.admin.mst.group.button.add') }}</mp-button>
        <mp-dialog regist :show="dialog.registComplete" @clickOk="goList" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminMstGroup, Common } from '@/api'
import MpError from '@/components/item/MpError'

export default {
  components: {
    MpError,
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog
  },
  data: () => ({
    id: null,
    view: {
      groupList: [],
      errors: []
    },
    form: {
      groupLargeId: null,
      groupSmallNameJp: null,
      groupSmallNameEn: null,
      companyLabelJp: null,
      companyLabelEn: null,
      branchLabelJp: null,
      branchLabelEn: null,
      displayOrder: null,
      accountEntryDisplayFlg: null,
      adminUpdFlg: null
    },
    dialog: {
      registComplete: false
    }
  }),
  computed: {
  },
  methods: {
    goList () {
      this.$router.push({ path: '/admin/mst/group/list' })
    },
    async goRegister () {
      await AdminMstGroup.register({
        ...this.form,
        accountEntryDisplayFlg: this.form.accountEntryDisplayFlg ? 0 : 1, // DB上は"表示フラグ"なので画面の値を反転させる
        adminUpdFlg: this.form.adminUpdFlg ? 1 : 0,
        groupSmallId: this.groupSmallId
      })
        .then(() => {
          this.dialog.registComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    }
  },
  created: async function () {
    this.view.groupList = await Common.groupList()
  }
}
</script>

<style scoped>
</style>
